import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/en.ts
var en_default = {
  "widgets.notifications.fusion-swap-view.status.pending": "Pending",
  "widgets.notifications.fusion-swap-view.status.filled": "Complete",
  "widgets.notifications.fusion-swap-view.status.false-predicate": "Filled",
  "widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance": "Filled",
  "widgets.notifications.fusion-swap-view.status.partially-filled": "Filled",
  "widgets.notifications.fusion-swap-view.status.wrong-permit": "Filled",
  "widgets.notifications.fusion-swap-view.status.invalid-signature": "Filled",
  "widgets.notifications.fusion-swap-view.status.expired": "Expired",
  "widgets.notifications.fusion-swap-view.status.cancelled": "Cancelled",
  "widgets.notifications.fusion-swap-view.control.cancel": "Cancel"
};
export {
  en_default as default
};
//# sourceMappingURL=en-LH2H6NI6.js.map
